export const DELETE_ID_CARD_QUERY_KEY = ['delete', 'ecards'] as const;
export const FILE_NAME = 'ID Card.pdf';
